import { SPECIAL_CONDITIONS_ENDPOINTS } from '@app/configs/api/specialConditions';
import { openPdfInNewWindow } from '@app/utils/pdfHandler';
import { baseApi } from './baseApi';
export const specialConditionsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSpecialConditions: builder.mutation({
            query: ({ loanId, amount }) => ({
                url: SPECIAL_CONDITIONS_ENDPOINTS.specialConditions,
                params: {
                    amount,
                    loanId,
                    contentDisposition: 'inline',
                },
                responseType: 'arraybuffer',
            }),
            transformResponse: (response) => {
                openPdfInNewWindow(response);
                return undefined;
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetSpecialConditionsMutation } = specialConditionsApi;
